// cart-drawer-toggle.js — unified PBCart + header badge & subtotal sync
(function () {
  function init() {
    const drawer = document.getElementById('UnifiedCartDrawer');
    if (!drawer) return;

    // Backdrop (created once)
    let backdrop = document.querySelector('.ucd-backdrop');
    if (!backdrop) {
      backdrop = document.createElement('div');
      backdrop.className = 'ucd-backdrop';
      document.body.appendChild(backdrop);
    }

    let scrollY = 0;

function openDrawer() {
  drawer.classList.add('is-open');
  backdrop.classList.add('is-visible');

  // iOS SAFE SCROLL LOCK
  scrollY = window.scrollY;
  document.body.style.position = 'fixed';
  document.body.style.top = `-${scrollY}px`;
  document.body.style.width = '100%';
}

function closeDrawer() {
  drawer.classList.remove('is-open');
  backdrop.classList.remove('is-visible');

  // RESTORE SCROLL
  document.body.style.position = '';
  document.body.style.top = '';
  document.body.style.width = '';
  window.scrollTo(0, scrollY);
}

    function toggleDrawer() {
      drawer.classList.contains('is-open') ? closeDrawer() : openDrawer();
    }

    // Close button, backdrop, Esc
    drawer.querySelector('.cart-drawer__close')?.addEventListener('click', closeDrawer);
    backdrop.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawer(); });

    // Public events
    document.addEventListener('cart:open', openDrawer);
    document.addEventListener('cart:close', closeDrawer);
    document.addEventListener('cart:toggle', toggleDrawer);

    // Hook cart icon
    const candidates = [
      'a[href$="/cart"]',
      '.header__icon--cart',
      '.header__cart',
      'button[data-open-cart]',
      '[data-header-cart]',
      '[data-cart-toggle]'
    ];
    const cartIcon = document.querySelector(candidates.join(','));
    cartIcon?.addEventListener('click', (ev) => {
      ev.preventDefault();
      openDrawer();
    });

    // Format € nicely
    function formatEUR(amount) {
      try {
        return new Intl.NumberFormat('nl-NL', {
          style: 'currency',
          currency: 'EUR'
        }).format(amount);
      } catch {
        return `€${amount.toFixed(2).replace('.', ',')}`;
      }
    }

    // 🔑 Unified cart: listen to pb:cart:updated
    document.addEventListener('pb:cart:updated', (e) => {
      const gqlCart = e.detail?.cart;

      // Auto-open drawer after addLine
      if (e.detail?.source === 'addLine') {
        setTimeout(() => openDrawer(), 60);
      }

      // Update header badge count
      const countEl = document.querySelector('[data-cart-count],[data-header-cart-count]');
      if (countEl && gqlCart?.totalQuantity != null) {
        countEl.textContent = gqlCart.totalQuantity;
      }

      // Update header subtotal if element exists
      const subEl = document.querySelector('[data-cart-subtotal]');
      const sub = gqlCart?.cost?.subtotalAmount;
      if (subEl && sub?.amount) {
        subEl.textContent = formatEUR(parseFloat(sub.amount));
      }
    });

    // Open when URL has ?viewcart=true or ?cartopen=true
    const qs = new URLSearchParams(location.search);
    if (qs.get('viewcart') === 'true' || qs.get('cartopen') === 'true') openDrawer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
